// Impressão: dois templates INDEPENDENTES (Pedido de Compra A4 e Etiqueta de Expedição).
// Cada um abre uma janela própria com CSS/@page auto-contido — sem CSS global compartilhado.

const esc = (v) => String(v ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export function openPrint(html) {
  const w = window.open("", "_blank", "width=980,height=760");
  if (!w) { alert("Permita pop-ups para imprimir/gerar PDF."); return; }
  w.document.open();
  w.document.write(html);
  w.document.close();
}

// ---------- PEDIDO DE COMPRA — documento administrativo A4 ----------
export function buildPedidoCompraHTML({ compra, empresaNome, logoUrl, cdNome, fornecedor, responsavel, statusLabel }) {
  const itens = compra.itens || [];
  const subtotal = itens.reduce((s, i) => s + i.qtd_solicitada * (i.custo_unitario || 0), 0);
  const totalItens = itens.reduce((s, i) => s + i.qtd_solicitada, 0);
  const linhas = itens.map((it) => `
    <tr>
      <td class="mono">${esc(it.sku)}</td>
      <td>${esc(it.nome)}${it.marca ? `<span class="muted"> · ${esc(it.marca)}</span>` : ""}</td>
      <td class="r">${it.qtd_solicitada}</td>
      <td class="c">${esc(it.unidade_medida || "un")}</td>
      <td class="r">R$ ${(it.custo_unitario || 0).toFixed(2)}</td>
      <td class="r">R$ ${(it.qtd_solicitada * (it.custo_unitario || 0)).toFixed(2)}</td>
    </tr>`).join("");
  const fornLinhas = [];
  if (fornecedor) {
    if (fornecedor.documento) fornLinhas.push(`<div><b>CNPJ/CPF:</b> ${esc(fornecedor.documento)}</div>`);
    if (fornecedor.contato) fornLinhas.push(`<div><b>Contato:</b> ${esc(fornecedor.contato)}</div>`);
    if (fornecedor.telefone) fornLinhas.push(`<div><b>Telefone:</b> ${esc(fornecedor.telefone)}</div>`);
    if (fornecedor.email) fornLinhas.push(`<div><b>E-mail:</b> ${esc(fornecedor.email)}</div>`);
  }
  const dataEmissao = (compra.data || compra.created_at || "").slice(0, 10).split("-").reverse().join("/");
  const geradoEm = new Date().toLocaleString("pt-BR");
  return `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${esc(compra.numero)}</title>
<style>
  @page { size: A4 portrait; margin: 14mm 12mm; }
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color: #111; font-size: 11pt; margin: 0; }
  .top { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #111; padding-bottom: 8px; }
  .co { display: flex; gap: 12px; align-items: center; }
  .co img { height: 54px; width: auto; object-fit: contain; }
  .co .nm { font-size: 15pt; font-weight: 800; text-transform: uppercase; }
  .co .un { font-size: 9pt; color: #444; }
  .title { text-align: right; }
  .title .t { font-size: 20pt; font-weight: 900; letter-spacing: 1px; }
  .title .n { font-family: monospace; font-size: 13pt; font-weight: 700; }
  .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin: 14px 0; }
  .box { border: 1px solid #ccc; border-radius: 6px; padding: 10px 12px; }
  .box h3 { margin: 0 0 6px; font-size: 9pt; text-transform: uppercase; color: #666; letter-spacing: .5px; }
  .box div { margin: 2px 0; font-size: 10pt; }
  table { width: 100%; border-collapse: collapse; margin-top: 6px; }
  thead { display: table-header-group; }
  th { background: #111; color: #fff; font-size: 9pt; text-transform: uppercase; padding: 6px 8px; text-align: left; }
  td { border-bottom: 1px solid #ddd; padding: 6px 8px; font-size: 10pt; }
  tr { page-break-inside: avoid; }
  .r { text-align: right; } .c { text-align: center; } .mono { font-family: monospace; } .muted { color: #888; }
  .totais { margin-top: 10px; display: flex; justify-content: flex-end; }
  .totais table { width: 46%; }
  .totais td { border: none; padding: 3px 6px; }
  .totais .grand td { border-top: 2px solid #111; font-size: 14pt; font-weight: 900; }
  .obs { margin-top: 14px; border: 1px solid #ccc; border-radius: 6px; padding: 10px 12px; }
  .obs h3 { margin: 0 0 4px; font-size: 9pt; text-transform: uppercase; color: #666; }
  .foot { position: fixed; bottom: 6mm; left: 12mm; right: 12mm; border-top: 1px solid #ccc; padding-top: 4px; font-size: 8pt; color: #666; display: flex; justify-content: space-between; }
</style></head><body onload="window.print()">
  <div class="top">
    <div class="co">
      ${logoUrl ? `<img src="${logoUrl}" alt="logo"/>` : ""}
      <div><div class="nm">${esc(empresaNome || "NEXO LOG")}</div><div class="un">Unidade/CD: ${esc(cdNome || "—")}</div></div>
    </div>
    <div class="title"><div class="t">PEDIDO DE COMPRA</div><div class="n">${esc(compra.numero)}</div></div>
  </div>
  <div class="grid2">
    <div class="box"><h3>Dados do Pedido</h3>
      <div><b>Nº:</b> ${esc(compra.numero)}</div>
      <div><b>Emissão:</b> ${esc(dataEmissao)}</div>
      <div><b>Responsável:</b> ${esc(responsavel || "—")}</div>
      <div><b>Status:</b> ${esc(statusLabel || compra.status)}</div>
    </div>
    <div class="box"><h3>Fornecedor</h3>
      <div><b>${esc(compra.fornecedor_nome)}</b></div>
      ${fornLinhas.join("")}
    </div>
  </div>
  <table>
    <thead><tr><th>SKU</th><th>Produto</th><th class="r">Qtd.</th><th class="c">Un.</th><th class="r">Valor Unit.</th><th class="r">Total</th></tr></thead>
    <tbody>${linhas}</tbody>
  </table>
  <div class="totais"><table>
    <tr><td>Itens</td><td class="r">${itens.length} produtos · ${totalItens} un</td></tr>
    <tr><td>Subtotal</td><td class="r">R$ ${subtotal.toFixed(2)}</td></tr>
    <tr class="grand"><td>VALOR TOTAL</td><td class="r">R$ ${subtotal.toFixed(2)}</td></tr>
  </table></div>
  ${compra.observacao ? `<div class="obs"><h3>Observações</h3><div>${esc(compra.observacao)}</div></div>` : ""}
  <div class="foot"><span>${esc(compra.numero)}</span><span>Gerado em ${esc(geradoEm)}</span><span>Gerado pelo NEXO LOG</span></div>
</body></html>`;
}

// ---------- ETIQUETA DE EXPEDIÇÃO — térmica ou A4 (1/2/4 por folha) ----------
export function buildEtiquetaHTML({ numero, destino, origem, data, payload, qr, formato = "TERMICA", subtipo = "ETIQUETA", perSheet = 1, copies = 1, volumes = null, tipoCompl = false }) {
  const n = Math.max(1, copies | 0);
  const label = (qrmm) => `
    <div class="lbl">
      <div class="hd"><span class="brand">⚡ NEXO LOG</span><span class="num">${esc(numero)}${tipoCompl ? " (C)" : ""}</span></div>
      <div class="dest"><div class="k">DESTINO</div><div class="v">${esc(destino || "—")}</div></div>
      <div class="meta">Origem: ${esc(origem || "CD")}${data ? " · " + esc(data) : ""}</div>
      <div class="qrwrap"><img src="${qr}" style="width:${qrmm}mm;height:${qrmm}mm"/></div>
      <div class="pl">${esc(payload)}</div>
    </div>`;

  let css, body;
  const common = `*{box-sizing:border-box} body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#000;background:#fff}
    .lbl{display:flex;flex-direction:column;background:#fff;color:#000;padding:5mm}
    .hd{display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #000;padding-bottom:2mm}
    .brand{font-weight:800;font-size:11pt} .num{font-family:monospace;font-weight:800;font-size:13pt}
    .dest .k{font-size:9pt;color:#444;margin-top:2mm} .dest .v{font-size:30pt;font-weight:900;line-height:1;text-transform:uppercase;word-break:break-word}
    .meta{font-size:9pt;margin-top:1mm} .qrwrap{flex:1;display:flex;align-items:center;justify-content:center;padding:2mm 0}
    img{display:block} .pl{font-family:monospace;font-size:8pt;text-align:center;word-break:break-all}`;

  if (formato === "MINI58") {
    // Knup KP-1025 (58 mm). Largura útil ~48 mm — conteúdo centralizado e QR como elemento principal.
    // subtipo: "ETIQUETA" (57×50 mm adesiva) ou "CONTINUA" (bobina 58 mm, altura automática).
    const isCont = subtipo === "CONTINUA";
    const useVol = !!(volumes && volumes > 1);
    const total = useVol ? (volumes | 0) : n;
    const mini = (i) => `
      <div class="lbl">
        <div class="brand">⚡ NEXO LOG</div>
        <div class="num">${esc(numero)}${tipoCompl ? " (C)" : ""}</div>
        <div class="destk">DESTINO</div>
        <div class="destv">${esc(destino || "—")}</div>
        <div class="qrwrap"><img src="${qr}" style="width:40mm;height:40mm"/></div>
        <div class="org">${esc(origem || "CD")} → ${esc(destino || "Unidade")}</div>
        ${useVol ? `<div class="vol">VOLUME ${i}/${total}</div>` : ""}
        <div class="pl">${esc(payload)}</div>
      </div>`;
    const commonMini = `*{box-sizing:border-box} body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#000;background:#fff}
      .lbl{display:flex;flex-direction:column;align-items:center;text-align:center;background:#fff;color:#000;width:58mm;padding:2mm 5mm}
      .brand{font-weight:800;font-size:9pt;margin-top:1mm}
      .num{font-family:monospace;font-weight:800;font-size:12pt;line-height:1.1}
      .destk{font-size:7pt;color:#444;margin-top:1mm} .destv{font-size:15pt;font-weight:900;line-height:1;text-transform:uppercase;word-break:break-word;max-width:48mm}
      .qrwrap{display:flex;justify-content:center;padding:1.5mm 0} img{display:block}
      .org{font-size:8pt} .vol{font-family:monospace;font-weight:800;font-size:11pt;border:1.5px solid #000;border-radius:2mm;padding:.5mm 2.5mm;margin-top:1mm}
      .pl{font-family:monospace;font-size:6.5pt;word-break:break-all;max-width:48mm;margin-top:.5mm}`;
    if (isCont) {
      // Bobina contínua: altura automática, só margem inferior para o corte na serrilha.
      css = `${commonMini} @page{size:58mm auto;margin:0}
        .lbl{padding-bottom:6mm} .lbl + .lbl{border-top:1px dashed #999}`;
    } else {
      // Etiqueta adesiva 57×50 mm, 1 por página.
      css = `${commonMini} @page{size:57mm 50mm;margin:0}
        .lbl{width:57mm;height:50mm;padding:1.5mm 4.5mm;page-break-after:always} .lbl:last-child{page-break-after:auto}
        .destv{font-size:12pt} .qrwrap img{width:30mm;height:30mm}`;
    }
    body = Array.from({ length: total }).map((_, i) => mini(i + 1)).join("");
  } else if (formato === "TERMICA") {
    css = `${common} @page{size:100mm 150mm;margin:0}
      .lbl{width:100mm;height:150mm;page-break-after:always} .lbl:last-child{page-break-after:auto}`;
    body = Array.from({ length: n }).map(() => label(45)).join("");
  } else {
    const cols = perSheet === 1 ? 1 : perSheet === 2 ? 1 : 2;
    const rows = perSheet === 1 ? 1 : 2;
    const qrmm = perSheet === 4 ? 26 : perSheet === 2 ? 34 : 50;
    const perN = perSheet;
    const sheets = Math.ceil(n / perN);
    let idx = 0; const sheetDivs = [];
    for (let s = 0; s < sheets; s++) {
      const cells = [];
      for (let c = 0; c < perN && idx < n; c++) { cells.push(label(qrmm)); idx++; }
      sheetDivs.push(`<div class="sheet">${cells.join("")}</div>`);
    }
    css = `${common} @page{size:A4;margin:8mm}
      .sheet{width:100%;height:281mm;display:grid;grid-template-columns:repeat(${cols},1fr);grid-template-rows:repeat(${rows},1fr);gap:6mm;page-break-after:always}
      .sheet:last-child{page-break-after:auto}
      .lbl{border:1px dashed #999} .dest .v{font-size:${perSheet === 4 ? 18 : 24}pt}`;
    body = sheetDivs.join("");
  }
  return `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Etiqueta ${esc(numero)}</title>
<style>${css}</style></head><body onload="window.print()">${body}</body></html>`;
}

// ---------- ETIQUETAS DE VOLUME — QR único por volume (57×50 mm ou 58 mm) ----------
export function buildVolumeLabelsHTML({ volumes = [], formato = "ETIQUETA57" }) {
  // volumes: [{ qr(dataURL), pedido_numero, carga_numero, seq, total, origem, destino, payload }]
  const isMini = formato === "MINI58";
  const label = (v) => `
    <div class="lbl">
      <div class="brand">⚡ NEXO LOG</div>
      <div class="num">${esc(v.pedido_numero || "")}</div>
      <div class="destk">DESTINO</div>
      <div class="destv">${esc(v.destino || "—")}</div>
      <div class="qrwrap"><img src="${v.qr}" /></div>
      <div class="org">${esc(v.origem || "CD")} → ${esc(v.destino || "Unidade")}</div>
      <div class="vol">VOLUME ${v.seq} DE ${v.total}</div>
      ${v.carga_numero ? `<div class="cg">Carga ${esc(v.carga_numero)}</div>` : ""}
      <div class="pl">${esc(v.payload || "")}</div>
    </div>`;
  const commonMini = `*{box-sizing:border-box} body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#000;background:#fff}
    .lbl{display:flex;flex-direction:column;align-items:center;text-align:center;background:#fff;color:#000;padding:1.5mm 4mm}
    .brand{font-weight:800;font-size:8pt;margin-top:1mm}
    .num{font-family:monospace;font-weight:800;font-size:11pt;line-height:1.1}
    .destk{font-size:6.5pt;color:#444;margin-top:.5mm} .destv{font-size:12pt;font-weight:900;line-height:1;text-transform:uppercase;word-break:break-word;max-width:48mm}
    .qrwrap img{width:26mm;height:26mm;display:block} .qrwrap{padding:1mm 0}
    .org{font-size:7pt} .vol{font-family:monospace;font-weight:800;font-size:11pt;border:1.5px solid #000;border-radius:2mm;padding:.5mm 2.5mm;margin-top:.5mm}
    .cg{font-size:6.5pt;margin-top:.5mm} .pl{font-family:monospace;font-size:6pt;word-break:break-all;max-width:48mm;margin-top:.5mm}`;
  let css;
  if (isMini) {
    css = `${commonMini} @page{size:58mm auto;margin:0} .lbl{width:58mm;padding-bottom:6mm} .lbl + .lbl{border-top:1px dashed #999}`;
  } else {
    css = `${commonMini} @page{size:57mm 50mm;margin:0} .lbl{width:57mm;height:50mm;page-break-after:always} .lbl:last-child{page-break-after:auto} .qrwrap img{width:22mm;height:22mm}`;
  }
  const body = volumes.map(label).join("");
  return `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Etiquetas de Volume</title>
<style>${css}</style></head><body onload="window.print()">${body}</body></html>`;
}
